import actionTypes from './actionTypes';
import service from '../../services/admin/banners';
import {getSubmitData} from './utils';
import {message} from 'antd';
import {SUCCESS_DELETED_MSG} from '../../utils';

const SERVER_BASE_ERROR_MSG = {level: 'error', text: "Error on server"};
const SUCCESS_UPDATE_MSG = {level: 'success', text: "Успішно збережено"};

function onInit() {
  return async (dispatch) => {
    onSetLoading(true)(dispatch);
    try {
      await fetchPartners()(dispatch);
      onSetLoading(false)(dispatch)
    } catch (err) {
      showMessage(SERVER_BASE_ERROR_MSG)(dispatch);
    }
  };
}

function fetchPartners() {
  return async (dispatch) => {
    try {
      const res = await service.getAll();
      dispatch({
        type: actionTypes.SET_PARTNERS,
        banners: res.data.banners
      });
    } catch (err) {
      showMessage(SERVER_BASE_ERROR_MSG)(dispatch);
    }
  }
}


function setInitial() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.BANNERS_SET_INITIAL_PARTNER
    })
  }
}


function onAdd() {
  return (dispatch) => {
    setInitial()(dispatch);
    showModal(true)(dispatch)
  }
}

function showModal(visible) {
  return (dispatch) => {
    if (visible) {
      dispatch({
        type: actionTypes.BANNERS_SHOW_FORM
      })
    } else {
      dispatch({
        type: actionTypes.BANNERS_HIDE_FORM
      })
    }

  }
}


function onCancel() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.BANNERS_HIDE_FORM
    })
  }
}


function onChangeInput(name, value) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.BANNERS_CHANGE_INPUT,
      name: name,
      value: value,
    })
  }
}

function onSetLoading(loading) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.LOADING,
      loading: loading,
    })
  }
}


export const onUpload = (e) => {
  return async (dispatch) => {
    onSetLoading(true)(dispatch);
    try {
      const res = await service.postFile(e.file);
      dispatch({
        type: actionTypes.BANNERS_SET_FILE,
        file: res.data.file,
      })
    } catch (err) {
      showMessage({level: 'error', text: "Error on upload file"})(dispatch);
    }
  }
};


function onSubmit() {
  return async (dispatch, getState) => {
    onSetLoading(true)(dispatch);
    try {
      const state = getState().banners;
      const data = getSubmitData(state);
      let res = null;
      if (state.editMode && state.banner) {
        res = await service.save(state.banner.id, data);
      } else {
        res = await service.add(data);
      }
      onSetLoading(false)(dispatch);
      if (res.data.status === 'ok') {
        fetchPartners()(dispatch);
        showModal(false)(dispatch);
        showMessage(SUCCESS_UPDATE_MSG)(dispatch);
      } else {
        setErrors(res.data.errors)(dispatch)
      }
    } catch (err) {
      showMessage(SERVER_BASE_ERROR_MSG)(dispatch);
    }
  };
}


export const setErrors = (errors) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.BANNERS_SET_ERRORS,
      errors: errors,
    })
  }
};


export const showMessage = (msg) => {
  return async (dispatch) => {
    message[msg.level](msg.text)
  }
};


function onEdit(itemId) {
  return async (dispatch) => {
    try {
      const res = await service.getById(itemId);
      if (res.data.status === 'ok') {
        setPartner(res.data.banner)(dispatch);
        showModal(true)(dispatch)
      }
    } catch (err) {
      showMessage(SERVER_BASE_ERROR_MSG)(dispatch);
    }
  };
}


export const setPartner = (banner) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.BANNERS_SET_PARTNER,
      banner: banner,
    })
  }
};


function onDelete(itemId) {
  return async (dispatch) => {
    try {
      onSetLoading(true)(dispatch);
      const res = await service.remove(itemId);
      if (res.data.status === 'ok') {
        await fetchPartners()(dispatch);
        onSetLoading(false)(dispatch);
        showMessage(SUCCESS_DELETED_MSG)(dispatch)
      }
    } catch (err) {
      showMessage(SERVER_BASE_ERROR_MSG)(dispatch);
    }
  };
}


export default {
  onInit,
  onAdd,
  onCancel,
  onUpload,
  onChangeInput,
  onSubmit,
  onEdit,
  onDelete,
}
